import React from "react";
import { ModalSubmit } from "components/common";
import { Button } from "components/bootstrap";
const EventDefinitionFormControls = ({
  action,
  activeStepIndex,
  onCancel,
  onOpenNextPage,
  onOpenPrevPage,
  onSubmit,
  steps
}) => {
  if (activeStepIndex === steps.length - 1) {
    return /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        onCancel,
        onSubmit,
        submitButtonText: `${action === "edit" ? "Update" : "Create"} event definition`
      }
    );
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", onClick: onOpenPrevPage, disabled: activeStepIndex === 0 }, "Previous"), /* @__PURE__ */ React.createElement("div", { className: "pull-right" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", onClick: onOpenNextPage }, "Next")));
};
export default EventDefinitionFormControls;
